var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87488 0.75H3.24998C2.91846 0.75 2.60053 0.881694 2.36611 1.11611C2.13169 1.35053 2 1.66846 2 1.99998V11.9998C2 12.3313 2.13169 12.6493 2.36611 12.8837C2.60053 13.1181 2.91846 13.2498 3.24998 13.2498H10.7498C11.0814 13.2498 11.3993 13.1181 11.6337 12.8837C11.8681 12.6493 11.9998 12.3313 11.9998 11.9998V3.87495L8.87488 0.75Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.75V3.24996C8.25 3.58147 8.38169 3.89941 8.61611 4.13382C8.85053 4.36824 9.16846 4.49993 9.49998 4.49993H11.9999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6.66602H5.91667C5.67355 6.66602 5.44039 6.76259 5.26849 6.9345C5.09658 7.10641 5 7.33957 5 7.58268C5 7.8258 5.09658 8.05895 5.26849 8.23086C5.44039 8.40277 5.67355 8.49935 5.91667 8.49935H7.75C7.99311 8.49935 8.22627 8.59593 8.39818 8.76783C8.57009 8.93974 8.66667 9.1729 8.66667 9.41602C8.66667 9.65913 8.57009 9.89229 8.39818 10.0642C8.22627 10.2361 7.99311 10.3327 7.75 10.3327H5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8335 11.25V5.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesV2);
export default __webpack_public_path__ + "static/media/salesV2.831f4aa09a6c190656f391223ca1162b.svg";
export { ForwardRef as ReactComponent };